import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { editorPages, editorCollections } from '../data/editor-pages';
import { CmsContentProvider, useCmsContent } from '../content/CmsContentContext';
import './admin.css';
import { ImageEditingProvider } from '../content/EditableImage';

const EditorFrame = ({ children }) => {
  const { cancel, save, saving, loaded, content } = useCmsContent();
  const location = useLocation();
  const navigate = useNavigate();
  const currentPage = location.pathname.replace(/\/$/, '');

  const changePage = (event) => {
    navigate(event.target.value);
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  return (
    <div className="cms-editor-shell">
      <div className="cms-editor-bar">
        <label className="cms-page-selector">
          <span>Page</span>
          <select aria-label="Page to edit" value={currentPage} onChange={changePage} disabled={saving || !loaded}>
            <optgroup label="Pages">
              {editorPages.map((page) => <option key={page.path} value={`/admin/edit${page.path}`}>{page.label}</option>)}
            </optgroup>
            {editorCollections.map((collection) => (
              <optgroup key={collection.key} label={collection.label}>
                {(content[collection.key] || []).map((page) => <option key={page.id} value={`/admin/edit${collection.path}/${page.id}`}>{page.title}</option>)}
              </optgroup>
            ))}
          </select>
        </label>
        <button className="cms-editor-cancel" type="button" onClick={cancel}>Cancel</button>
        <button type="button" disabled={saving} onClick={save}>Save</button>
      </div>
      {children}
    </div>
  );
};

const AdminEditor = ({ children }) => (
  <CmsContentProvider mode="editor">
    <ImageEditingProvider><EditorFrame>{children}</EditorFrame></ImageEditingProvider>
  </CmsContentProvider>
);

export default AdminEditor;
